// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FsJS","col":"styles_col__1F48J"};